import Swiper from '@iris.interactive/handcook/public/scripts/libraries/swiper-11'

export default class StrateMomentsComponent {
    static $parentSelector = $("[data-swiper='strate-moments-mobile-slider-container']")
    static momentsSwiper

    constructor() {
        if ($('.strate--moments').length > 0) {
            StrateMomentsComponent.breakpointManager()

            window.addEventListener('resize', StrateMomentsComponent.breakpointManager)
        }
    }

    static breakpointManager() {
        // checks if we're on mobile
        if (window.matchMedia('(max-width: 1000px)').matches) {
            StrateMomentsComponent.onMedium()
        } else {
            StrateMomentsComponent.onDesktop()
        }
    }

    static async onMedium() {
        const $parentSelector = StrateMomentsComponent.$parentSelector

        if ($parentSelector.length > 0 && !$parentSelector.hasClass('hasSlider')) {
            $parentSelector.addClass('hasSlider')

            const options = {
                mousewheel: {
                    forceToAxis: true,
                },
                slidesPerView: 1,
                spaceBetween: 10,
                speed: 200,
                keyboard: true,
                loop: false,
                passiveListeners: false,
                watchSlidesVisibility: false,
            }

            $parentSelector
                .find('[data-element="mobile-slide"]')
                .addClass('swiper-slide')
                .wrapAll(
                    '<div class="swiper" data-swiper="strate-moments-mobile-slider"><div class="swiper-wrapper">',
                )

            StrateMomentsComponent.momentsSwiper = await Swiper.create(
                '[data-swiper="strate-moments-mobile-slider"]',
                options,
            )
        }
    }

    static onDesktop() {
        const $parentSelector = StrateMomentsComponent.$parentSelector

        if ($parentSelector.hasClass('hasSlider')) {
            $parentSelector
                .find('[data-element="mobile-slide"]')
                .removeClass('swiper-slide')
                .unwrap('.swiper-wrapper')
                .unwrap('.swiper')

            if (StrateMomentsComponent.momentsSwiper !== undefined) {
                StrateMomentsComponent.momentsSwiper.destroy()
            }

            $parentSelector.removeClass('hasSlider')
        }
    }
}
